<template>
    <div class="fondovista">  
        <div class="container">
            <transition name="slide-fade" appear>
                <b-card>
                    <div class="mt-2"><strong>GESTIÓN DE TAREAS / ACTIVIDADES</strong> | Docente: <strong>{{ datosSesion.nombres }} {{ datosSesion.apellidos }}</strong></div>
                    <hr>
                    <b-row>
                        <b-col md="12">
                            <b-form-group class="small" label="Seleccione un Aula / Asignatura:" label-for="aulas">
                                <b-form-select size="sm" id="aulas" v-model="idAsignaturaDocente" :options="listaComboAsignaturasDocente" @change="cargaActividades()">
                                    <template slot="first"><option :value="null" disabled>-- Seleccione un Aula --</option></template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.idAsignaturaDocente">
                        <b-col v-if="!this.verModalCrear && !this.verModalEditar">
                            <vue-good-table
                                :columns="titulos"
                                :line-numbers="true"
                                :search-options="{
                                    enabled: true,
                                    placeholder: 'Buscar...'
                                }"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    nextLabel: 'Siguiente',
                                    prevLabel: 'Anterior',
                                    rowsPerPageLabel: 'Filas por página',
                                    ofLabel: 'de',
                                    pageLabel: 'página',
                                    allLabel: 'Todo'
                                }"
                                styleClass="vgt-table bordered condensed striped sm"
                                :rows="actividadesAula"
                                >
                                <div slot="table-actions">
                                    <b-button size="sm" class="mr-2 ml-5" variant="success" @click="formularioNuevaActividad()">Nueva Actividad</b-button>
                                </div>
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field === 'acciones'">
                                        <a href="#" class="text-decoration-none mx-3 text-warning" @click="verModalEditarFecha=true, idActividad=props.row.id, tituloActividad=props.row.titulo" v-b-tooltip.hover title="Cambiar Fecha de Cierre"><i class="fas fa-calendar-day"></i></a>
                                        <a href="#" class="text-decoration-none mx-2" @click="editarActividad(props.row)" v-b-tooltip.hover title="Editar Actividad"><i class="fas fa-edit"></i></a>
                                        <a href="#" class="text-decoration-none ml-3 text-danger" @click="verModalEliminar=true, idActividad=props.row.id, tituloActividad=props.row.titulo" v-b-tooltip.hover title="Eliminar Actividad"><i class="fas fa-trash-alt"></i></a>
                                    </span>
                                </template>
                            </vue-good-table>
                        </b-col>
                        <b-col v-if="this.verModalCrear">
                            <b-card bg-variant="light">
                                <b-card-text>
                                    <b-row>
                                        <b-col lg="12">
                                            <p><strong>FORMULARIO: NUEVA ACTIVIDAD</strong></p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="8">
                                            <b-form-group class="small" label="Titulo de la Actividad: *" label-for="titulo">
                                                <b-form-input type="text" size="sm" id="titulo" v-model="nuevaActividad.titulo" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="2">
                                            <b-form-group class="small" label="Fecha Vigencia: *" label-for="vigencia">
                                                <b-form-input type="date" size="sm" id="vigencia" v-model="nuevaActividad.fecha_vigencia" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="2">
                                            <b-form-group class="small" label="Hora Cierre: *" label-for="cierre">
                                                <b-form-input type="time" size="sm" id="cierre" v-model="nuevaActividad.hora_vigencia" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="12">
                                            <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
                                        </b-col>
                                    </b-row>
                                    <br>
                                    <b-button size="sm" variant="success" class="px-5" @click="insertarActividad()"> Crear Actividad</b-button>
                                    <b-button size="sm" variant="" class="ml-3" @click="cancel()"> Cancelar </b-button>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col v-if="this.verModalEditar">
                            <b-card bg-variant="light">
                                <b-card-text>
                                    <b-row>
                                        <b-col lg="12">
                                            <p><strong>FORMULARIO: EDITAR ACTIVIDAD</strong></p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="8">
                                            <b-form-group class="small" label="Titulo de la Actividad: *" label-for="titulo">
                                                <b-form-input type="text" size="sm" id="titulo" v-model="registroActividad.titulo"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="4">
                                            <b-form-group class="small" label="Fecha de Entrega:" label-for="vigencia">
                                                <b-form-input type="text" size="sm" id="vigencia" v-model="fvigencia" disabled></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="12">
                                            <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6">
                                            <label class="small">Fecha Publicación: <em>{{fpublicacion}}</em></label>
                                        </b-col>
                                        <b-col lg="6">
                                            <label class="small">Última Actualización: <em>{{factualizacion}}</em></label>
                                        </b-col>
                                    </b-row>
                                    <br>
                                    <b-button size="sm" variant="success" class="px-5" @click="actualizarActividad()"> Actualizar Actividad</b-button>
                                    <b-button size="sm" variant="" class="ml-3" @click="cancel()"> Cancelar </b-button>
                                </b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
            </transition>
        </div>
        <b-modal title="Eliminar Actividad" header-bg-variant="danger" header-text-variant="light" v-model="verModalEliminar">
            <p class="text-center my-2" style="font-size: 80px; color: red"><i class="fas fa-trash-alt"></i></p>
            <p class="text-center my-2">Va a Eliminar la Actividad:<br><strong>{{ this.tituloActividad }}</strong><br>Está seguro que desea eliminar la actividad?<br></p>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button class="px-5" size="sm" variant="danger" @click="eliminarActividad">Eliminar</b-button>
                <b-button class="px-2" size="sm" variant="" @click="cancel()">Cancelar </b-button>
            </template>
        </b-modal>
        <b-modal title="Cambiar Fecha Cierre" header-bg-variant="warning" header-text-variant="light" v-model="verModalEditarFecha">
            <p class="text-center my-2" style="font-size: 40px; color: yellow"><i class="fas fa-calendar-day"></i></p>
            <p class="text-center my-2">Ingrese la nueva fecha y hora de cierre de la Actividad:<br><strong>{{ this.tituloActividad }}</strong></p><hr>
            <b-row>
                <b-col lg="6">
                    <b-form-group class="small" label="Nueva Fecha Vigencia: *" label-for="nuevafecha">
                        <b-form-input type="date" size="sm" id="nuevafecha" v-model="nuevaFechaVigencia" required></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group class="small" label="Nueva Hora Cierre: *" label-for="nuevahora">
                        <b-form-input type="time" size="sm" id="nuevahora" v-model="nuevaHoraVigencia" required></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button class="px-5" size="sm" variant="success" @click="cambiarFechaActividad">Cambiar</b-button>
                <b-button class="px-2" size="sm" variant="" @click="cancel()">Cancelar </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import * as CONFIG from '@/assets/config.js'
    import {mapState} from 'vuex'
    import ClassicEditor  from '@ckeditor/ckeditor5-build-classic'
 		ClassicEditor
 			.create( document.querySelector( '#editor' ), {
 				cloudServices: {
 					tokenUrl: 'https://70206.cke-cs.com/token/dev/MlgjpjzMnRE3WJsMGtc6DvcoripRDjXOqPnBpCoC2mpEhG6F9CYQHtIzgcc1',
 					uploadUrl: 'https://70206.cke-cs.com/easyimage/upload/'
 				}
 			} )
 			.then( editor => {
				alert("Editor: " + editor );
			} )
 			.catch( error => {
				alert("Error: " + error )
            } );
    export default {
        name: 'GestionContenidos',
        components: {
        },
        data() {
            return {
                asignaturasDocente: [],
                listaComboAsignaturasDocente: [],
                idAsignaturaDocente: null,
                descripcionAsignaturasGrados: [],
                actividadesAula: [],
                titulos: [
                    { label: "Actividades para el Aula", field: "titulo", sortable: false },
                    { label: "Fecha Cierre", field: "vigencia", sortable: false, tdClass: this.claseFechaCierre, width: '150px' },
                    { label: "Acciones", field: "acciones", sortable: false, width: '150px' }
                ],
                editor: ClassicEditor,
                editorData: '',
                editorConfig: {},
                nuevaActividad: {
                    titulo: '',
                    contenido: '',
                    fecha_vigencia: null,
                    hora_vigencia: null,
                    id_asignatura_docente: ''
                },
                verModalCrear: false,
                verModalEditar: false,
                verModalEliminar: false,
                idActividad: null,
                tituloActividad: null,
                verModalEditarFecha: false,
                nuevaFechaVigencia: null,
                nuevaHoraVigencia: null
            }
        },
        methods: {
            async cambiarFechaActividad() {
                if (this.nuevaFechaVigencia != '' && this.nuevaFechaVigencia != null && this.nuevaHoraVigencia != null && this.nuevaHoraVigencia != '') {
                    let fechahoranueva = this.nuevaFechaVigencia + 'T' + this.nuevaHoraVigencia
                    await axios
                    .put(CONFIG.ROOT_PATH + "actividades/fechacierre/" + this.idActividad,JSON.stringify({fechahoranueva}),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                        .then(response => {
                        if (response.data.error){
                            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                        } else{
                            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                        }
                    })
                    .catch(err => {
                    if (err.message === "Network Error")
                        this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                    else
                        this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                    })
                    this.verModalEditarFecha = false
                    this.cargaActividades()
                } else {
                    this.mensajeEmergente("danger","Mensaje","Uno de los campos no es válido. Revise que la Fecha y/o la Hora no esten vacios.");
                }
            },
            async eliminarActividad() {
                await axios
                .delete(CONFIG.ROOT_PATH + "actividades/" + this.idActividad)
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.cargaActividades()
                this.verModalEliminar = false
                this.verModalCrear = false
                this.verModalEditar = false
            },
            async actualizarActividad() {
                if (this.registroActividad.titulo != '') {
                    this.registroActividad.contenido = this.editorData
                    await axios
                    .put(CONFIG.ROOT_PATH + "actividades/" + this.registroActividad.id,JSON.stringify(this.registroActividad),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                        .then(response => {
                        if (response.data.error){
                            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                        } else{
                            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                        }
                    })
                    .catch(err => {
                    if (err.message === "Network Error")
                        this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                    else
                        this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                    })
                    this.verModalCrear = false
                    this.verModalEditar = false
                    this.cargaActividades()
                } else {
                    this.mensajeEmergente("danger","Mensaje","Uno de los campos no es válido. Revise que el Titulo no este vacio.");
                }
            },
            editarActividad(actividad) {
                this.fpublicacion = new Date(actividad.fecha_publicacion)
                this.fpublicacion = this.fpublicacion.toLocaleDateString() + ' a las ' + this.fpublicacion.toLocaleTimeString()
                this.factualizacion = new Date(actividad.fecha_actualizacion)
                this.factualizacion = this.factualizacion.toLocaleDateString() + ' a las ' + this.factualizacion.toLocaleTimeString()
                this.fvigencia = new Date(actividad.fecha_vigencia)
                this.fvigencia = this.fvigencia.toLocaleDateString() + ' hasta las ' + this.fvigencia.toLocaleTimeString()
                this.registroActividad = actividad
                this.editorData = this.registroActividad.contenido
                this.verModalCrear = false
                this.verModalEditar = true
            },
            async insertarActividad() {
                if (this.nuevaActividad.fecha_vigencia != '' && this.nuevaActividad.fecha_vigencia != null && this.nuevaActividad.hora_vigencia != null && this.nuevaActividad.hora_vigencia != '' && this.nuevaActividad.titulo != '') {
                    let fechahoranueva = this.nuevaActividad.fecha_vigencia + 'T' + this.nuevaActividad.hora_vigencia
                    this.nuevaActividad.fecha_vigencia = fechahoranueva
                    this.nuevaActividad.contenido = this.editorData
                    await axios
                    .post(CONFIG.ROOT_PATH + "actividades", JSON.stringify(this.nuevaActividad), { headers: {"Content-Type": "application/json; charset=utf-8" }})
                        .then(response => {
                        if (response.data.error){
                            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                        } else{
                            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                        }
                    })
                    .catch(err => {
                    if (err.message === "Network Error")
                        this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                    else
                        this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                    })
                    this.verModalCrear = false
                    this.cargaActividades()
                } else {
                    this.mensajeEmergente("danger","Mensaje","Uno de los campos no es válido. Revise que el Titulo, fecha Vigencia y la Hora Cierre estén correctas.");
                }
            },
            formularioNuevaActividad() {
                this.nuevaActividad.titulo = '',
                this.nuevaActividad.contenido = '',
                this.nuevaActividad.fecha_vigencia = null,
                this.nuevaActividad.hora_vigencia = null,
                this.nuevaActividad.id_asignatura_docente = this.idAsignaturaDocente,
                this.editorData = '<p>Ingrese el contenido de la Nueva Actividad.</p><p></p><p></p><p></p>',
                this.verModalEditar = false
                this.verModalCrear = true
            },
            async cargarAsignaturasDocente() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/docente/" + this.datosSesion.idUsuario)
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.asignaturasDocente = response.data.datos
                        for (let i = 0; i < this.asignaturasDocente.length; i++) {
                            for (let j = 0; j < this.descripcionAsignaturasGrados.length; j++) {
                                if (this.asignaturasDocente[i].id_asignatura_grado == this.descripcionAsignaturasGrados[j].id_asignatura_grado) {
                                    this.listaComboAsignaturasDocente.push({value: this.asignaturasDocente[i].id_asignatura_docente, text: this.asignaturasDocente[i].nomenclatura + ' | ' + this.descripcionAsignaturasGrados[j].descripcion})
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })                
            },
            async cargarDescripcionAsignaturasGrados() {
                await axios
                .get(CONFIG.ROOT_PATH + "asignaturas/descripcionasignaturasgrados")
                    .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.descripcionAsignaturasGrados = response.data.datos
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
            },
            async cargaActividades() {
                await axios
                .get(CONFIG.ROOT_PATH + "actividades/aula/" + this.idAsignaturaDocente)
                    .then(response => {
                    if (response.data.error){
                        this.actividadesAula = []
                        this.mensajeEmergente("danger","Mensaje",'No existen Actividades para el Aula seleccionada.')
                    } else{
                        this.actividadesAula = []
                        this.actividadesAula = response.data.datos
                        this.actividadesAula.forEach((element) => {
                            element.estado = this.validarFechaVigencia(element.fecha_vigencia)
                            let fvigencia = new Date(element.fecha_vigencia)
                            element.vigencia = fvigencia.toLocaleDateString() + ' | ' + fvigencia.toLocaleTimeString()
                        });
                    }
                })
                .catch(err => {
                if (err.message === "Network Error")
                    this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
                else
                    this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
                })
                this.verModalCrear = false
            },
            validarFechaVigencia(fecha) {
                let fechaAhora = new Date()
                let fechaVigencia = new Date(fecha) 
                if (fechaVigencia.getTime() >= fechaAhora.getTime())
                    return true
                else 
                    return false
            },
            claseFechaCierre(row) {
                return (row.estado == false ? 'text-danger' : 'text-success')
            },
            cancel() {
                this.verModalEditar = false
                this.verModalCrear = false
            },
            mensajeEmergente(variante, titulo, contenido) {
                this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
            }
        },
        beforeMount() {
            this.cargarDescripcionAsignaturasGrados()
            this.cargarAsignaturasDocente()
        },
        computed: {
            ...mapState(['datosSesion'])
        }
    }
</script>